/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ParcoursInterneSearch
 */
export interface ParcoursInterneSearch {
    /**
     * 
     * @type {number}
     * @memberof ParcoursInterneSearch
     */
    idParcoursFormation?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParcoursInterneSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ParcoursInterneSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ParcoursInterneSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ParcoursInterneSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ParcoursInterneSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ParcoursInterneSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ParcoursInterneSearch interface.
 */
export function instanceOfParcoursInterneSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ParcoursInterneSearchFromJSON(json: any): ParcoursInterneSearch {
    return ParcoursInterneSearchFromJSONTyped(json, false);
}

export function ParcoursInterneSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcoursInterneSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idParcoursFormation': !exists(json, 'idParcoursFormation') ? undefined : json['idParcoursFormation'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ParcoursInterneSearchToJSON(value?: ParcoursInterneSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idParcoursFormation': value.idParcoursFormation,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

